"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var Typography_1 = __importDefault(require("../Typography"));
var Radio_1 = __importDefault(require("./Radio"));
var RadioGroup = function (_a) {
    var label = _a.label, options = _a.options, selectedOption = _a.selectedOption, onChange = _a.onChange;
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, __assign({ variant: "textSmall", margin: "xs", component: "h3", uppercase: true, weight: 'bold' }, { children: label }), void 0), options.map(function (option, index) { return ((0, jsx_runtime_1.jsx)(Radio_1.default, { style: index ? { marginLeft: 16 } : undefined, handleInputChange: onChange, checked: option.value === selectedOption, label: option.label, value: option.value }, option.value)); })] }, void 0));
};
exports.default = RadioGroup;
//# sourceMappingURL=index.js.map